// Open Submenus on click

let mainNav = document.querySelector('.main-nav');

if (mainNav) {
    let level1Links = document.querySelectorAll('.main-nav__link--level-1.main-nav__link--sub');
    [...level1Links].forEach(link => {
        link.addEventListener('click', event => {
            removeAllOpenStates();
            link.parentNode.classList.add('open');
            link.setAttribute('aria-expanded', true);
        });
    });
}

function removeAllOpenStates() {
    let openElements = document.querySelectorAll('.main-nav__item--level-1.open');
    [...openElements].forEach(e => {
        e.classList.remove('open');
        [...e.querySelectorAll('.main-nav__link--level-1')].forEach(link => {
            link.setAttribute('aria-expanded', false);
        });
    });
}

// Close all when clicked somewhere else
document.body.addEventListener(
    'click',
    function() {
        removeAllOpenStates();
    },
    false
);

document.addEventListener(
    'keyup',
    e => {
        if (e.key === 'Escape') {
            removeAllOpenStates();
        }
    },
    false
);

if (mainNav) {
    mainNav.addEventListener(
        'click',
        function(ev) {
            ev.stopPropagation();
        },
        false
    );
}
